import request from '@/utils/request'

// 查询计量机构信息列表
export function listJljgxx(query) {
  return request({
    url: '/web/zlts/jljgxx/list',
    method: 'get',
    params: query
  })
}
  // 组装单点登录所需信息，计量单点信息加密
  export function getSsoDesInfo(query) {
    return request({
      url: '/web/productTest/getSsoDesInfo/',
      method: 'get',
      params: query
    })
}